import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  n: '1',
  title: 'Instant download',
  desc: 'Purchase and get immediate access to the complete ebook and all 5 bonuses. Start whenever you want, no waiting.'
}, {
  n: '2',
  title: 'Follow the visual method',
  desc: 'Learn Hangul, pronunciation, vocabulary and phrases in an order designed so you never get lost. The system is your roadmap.'
}, {
  n: '3',
  title: 'Complete the 30-day routine',
  desc: 'Study step by step, practice what you learned and consolidate your memory to speak with real confidence by day 30.'
}];
export function Steps() {
  return <section aria-label="How it works" className="bg-transparent" data-id="element-161" data-mp="bq6x2jol9vtp">
      <div className="mx-auto max-w-4xl px-5 py-12" data-id="element-162" data-mp="fpxsj0p2904k">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-163" data-mp="2624w5st6pbbv">
          How You'll Progress Starting Today
        </h2>
        <p className="mt-3 text-center text-sm text-plum/60" data-id="element-164" data-mp="2a2x5sn5yxi8o">In just 3 simple steps</p>

        <ol className="mt-10 space-y-4" data-id="element-165" data-mp="1qa11lpnwdbdu">
          {steps.map((s, i) => <motion.li key={s.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-start gap-4 rounded-2xl border border-grape/15 bg-white p-5" data-id="element-166" data-mp="1ld0xhkalyipd" data-mpi={i}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-grape font-display text-base font-black text-white" data-id="element-167" data-mp="12e6l2hym9ucd">
                {s.n}
              </span>
              <div data-id="element-168" data-mp="1cbb7miwdjrtp">
                <h3 className="text-base font-bold text-plum" data-id="element-169" data-mp="1carpb12tb1f5">{s.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-170" data-mp="2spb1bc4mml8i">{s.desc}</p>
              </div>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}